import React, { useState } from "react";
import _ from 'lodash';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import 'dayjs/locale/ko';

export function Dropdown({
  optionList,
  filterOption,
  setFilterOption,
  default_date,
  setIsApply,
  activeType2
}) {

  const [dateRange, setDateRange] = useState(filterOption.dateRange);

  const [project, setProject] = useState(filterOption.project);
  const [area1, setArea1] = useState(filterOption.area1);
  const [area2, setArea2] = useState(filterOption.area2);
  const [construction1, setConstruction1] = useState(filterOption.construction1);
  const [construction2, setConstruction2] = useState(filterOption.construction2);
  const [step, setStep] = useState(filterOption.step);
  const [job, setJob] = useState(filterOption.job);
  const [vendor, setVendor] = useState(filterOption.vendor);



  const handleProjectChange = (e) => {
    setProject(e.target.value);
    setArea1("전체");
  }

  const handleVendorChange = (e) => {
    setVendor(e.target.value);
  }

  const handleAreaLv1Change = (e) => {
    setArea1(e.target.value);
    setArea2("전체")
    setConstruction1("전체")
    setConstruction2("전체")
    setStep("전체")
    setJob("전체")
    // setDateRange(default_date);
  };
  const handleAreaLv2Change = (e) => {
    setArea2(e.target.value);
    setConstruction1("전체")
    setConstruction2("전체")
    setStep("전체")
    setJob("전체")
    // setDateRange(default_date);
  };
  const handleConstructionLv1Change = (e) => {
    setConstruction1(e.target.value);
    setConstruction2("전체")
    setStep("전체")
    setJob("전체")
    // setDateRange(default_date);
  };
  const handleConstructionLv2Change = (e) => {
    setConstruction2(e.target.value);
    setStep("전체")
    setJob("전체")
    // setDateRange(default_date);
  };
  const handleStepChange = (event, newValue) => {
    setStep(newValue);
    setJob("전체");
    // setDateRange(default_date);
  };
  const handleJobChange = (e) => {
    setJob(e.target.value);
    // setDateRange(default_date);
  };

  const handleResetClick = (e) => {
    setProject("전체");
    setArea1("전체");
    setArea2("전체");
    setConstruction1("전체");
    setConstruction2("전체");
    setStep("전체");
    setJob("전체");
    setVendor("전체");
    setDateRange(default_date);
  };
  const [value, setValue] = useState([dayjs().subtract(1, "year"), dayjs()])

  const apply = () => {
    setIsApply(true);
    setFilterOption({
      project: project,
      area1: area1,
      area2: area2,
      construction1: construction1,
      construction2: construction2,
      step: step,
      job: job,
      vendor: vendor,
      dateRange: { start: value.map(v => new Date(dayjs(v).format("YYYY-MM-DD")))[0], end: value.map(v => new Date(dayjs(v).format("YYYY-MM-DD")))[1] },
    });
  };



  return (
    <div
      className="menu menu-sub menu-sub-dropdown d-flex position-absolute w-md-600px"
      style={{ zIndex: 99 }}
    >
      <div className="px-7 py-5">
        <div className="fs-5 text-dark fw-bolder">Filter Options</div>
      </div>
      <div className="separator border-gray-200" />
      <div className="px-7 py-5 ">
        <div className="z-3">
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DemoContainer components={['DateRangePicker', 'DateRangePicker']}>
              <DemoItem label="분석 기간" component="DateRangePicker">
                <DateRangePicker
                  value={value}
                  onChange={(newValue) => setValue(newValue)}
                />
              </DemoItem>
            </DemoContainer>
          </LocalizationProvider>
        </div>
      </div>
      <div className="separator border-gray-200" />

      <div className="px-7 py-5" style={{ width: "585px" }}>
        <label className="form-label fw-bold">Project:</label>
        <div>
          <select
            className="form-select form-select-solid"
            data-kt-select2="true"
            data-placeholder="Select option"
            data-allow-clear="true"
            value={project}
            onChange={handleProjectChange}
            defaultValue="전체"
          >
            <option>전체</option>
            {getUniqueValues(optionList, "project_projectname").map(
              (option, idx) => (
                <option key={idx}>{option}</option>
              ),
            )}
          </select>
        </div>
      </div>
      <div className="px-7 py-5" style={{ width: "585px" }}>
        <label className="form-label fw-bold">업체명:</label>
        <div>
          <select
            className="form-select form-select-solid"
            data-kt-select2="true"
            data-placeholder="Select option"
            data-allow-clear="true"
            value={vendor}
            onChange={handleVendorChange}
            defaultValue="전체"
          >
            <option>전체</option>
            {getUniqueValues(optionList, "uveVendorNameTB50").map(
              (option, idx) => (
                <option key={idx}>{option}</option>
              ),
            )}
          </select>
        </div>
      </div>
      <div className="px-7 py-5 pb-0 h-505px scroll d-flex flex-row">
        <div className="d-flex flex-column w-250px " style={{ marginRight: "40px" }}>

          {project !== "전체" ?
            <>
              <div className="mb-10">
                <label className="form-label fw-bold">Area Lv.1:</label>
                <div>
                  <select
                    className="form-select form-select-solid"
                    data-kt-select2="true"
                    data-placeholder="Select option"
                    data-allow-clear="true"
                    value={area1}
                    onChange={handleAreaLv1Change}
                    defaultValue="전체"
                  >
                    <option>전체</option>
                    {getUniqueValues(
                      optionList.filter(

                        (c) =>
                          (project === "전체" ? c.project_projectname : c.project_projectname === project) &&
                          (vendor === "전체" ? c.uveVendorNameTB50 : c.uveVendorNameTB50 === vendor)
                      ),
                      "WBSCodeNMLv2",
                    ).map((option, idx) => (
                      <option key={idx}>{option}</option>
                    ))}
                  </select>
                </div>
              </div>

            </> : ""}

          <div className="mb-0">
            <label className="form-label fw-bold">공종 Lv.1:</label>
            <div>
              <select
                className="form-select form-select-solid"
                data-kt-select2="true"
                data-placeholder="Select option"
                data-allow-clear="true"
                value={construction1}
                onChange={handleConstructionLv1Change}
                defaultValue="전체"
              >
                <option>전체</option>
                {getUniqueValues(
                  optionList.filter(

                    (c) =>
                      (project === "전체" ? c.project_projectname : c.project_projectname === project) &&
                        (vendor === "전체" ? c.uveVendorNameTB50 : c.uveVendorNameTB50 === vendor) &&
                        area1 === "전체" ? c.WBSCodeNMLv2 : c.WBSCodeNMLv2 === area1
                  ),
                  "WBSCodeNMLv4",
                ).map((option, idx) => (
                  <option key={idx}>{option}</option>
                ))}
              </select>
            </div>
          </div>

        </div>
        <div className="d-flex flex-column w-250px">
          {project !== "전체" ?
            <>
              <div className="mb-10">
                <label className="form-label fw-bold">Area Lv.2:</label>
                <div>
                  <select
                    className="form-select form-select-solid"
                    data-kt-select2="true"
                    data-placeholder="Select option"
                    data-allow-clear="true"
                    value={area2}
                    onChange={handleAreaLv2Change}
                    defaultValue="전체"
                  >
                    <option>전체</option>
                    {getUniqueValues(
                      optionList.filter((c) => c.WBSCodeNMLv2 === area1),
                      "WBSCodeNMLv3",
                    ).map((option, idx) => (
                      <option key={idx}>{option}</option>
                    ))}
                  </select>
                </div>
              </div>
            </> : ""
          }

          <div className="mb-0">
            <label className="form-label fw-bold">공종 Lv.2:</label>
            <div>
              <select
                className="form-select form-select-solid"
                data-kt-select2="true"
                data-placeholder="Select option"
                data-allow-clear="true"
                value={construction2}
                onChange={handleConstructionLv2Change}
                defaultValue="전체"
              >
                <option>전체</option>
                {getUniqueValues(
                  optionList.filter(
                    (c) =>
                      (project === "전체" ? c.project_projectname : c.project_projectname === project) &&
                      (vendor === "전체" ? c.uveVendorNameTB50 : c.uveVendorNameTB50 === vendor) &&
                      (area1 === "전체" ? c.WBSCodeNMLv2 : c.WBSCodeNMLv2 === area1) &&
                      (area2 === "전체" ? c.WBSCodeNMLv3 : c.WBSCodeNMLv3 === area2) &&
                      c.WBSCodeNMLv4 === construction1,
                  ),
                  "WBSCodeNMLv5",
                ).map((option, idx) => (
                  <option key={idx}>{option}</option>
                ))}
              </select>
            </div>
          </div>

        </div>
      </div>
      <div className="px-7 py-5 mb-0" style={{ width: "585px" }}>
        <label className="form-label fw-bold">작업 종류:</label>
        <div>
          <Autocomplete
            value={step}
            onChange={(event, newValue) => {
              setStep(newValue ?? ""); // newValue가 null일 경우 빈 문자열을 설정
            }}
            onInputChange={(event, newInputValue) => {
              setStep(newInputValue ?? ""); // newInputValue가 null일 경우 빈 문자열을 설정
            }}
            inputValue={step}
            options={["전체", ...getUniqueValues(
              optionList.filter(
                (c) =>
                  (project === "전체" ? c.project_projectname : c.project_projectname === project) &&
                  (vendor === "전체" ? c.uveVendorNameTB50 : c.uveVendorNameTB50 === vendor) &&
                  (area1 === "전체" ? true : c.WBSCodeNMLv2 === area1) &&
                  (area2 === "전체" ? true : c.WBSCodeNMLv3 === area2) &&
                  (construction1 === "전체" ? true : c.WBSCodeNMLv4 === construction1) &&
                  (construction2 === "전체" ? true : c.WBSCodeNMLv5 === construction2),
              ),
              "step"
            )]}
            renderInput={(params) => <TextField {...params} label="" />}
          />

        </div>
      </div>

      <div className="separator border-gray-200" />
      {step !== "전체" ?
        <div>
          <div className="px-7 py-5 " style={{ width: "585px" }}>
            <label className="form-label fw-bold">직종:</label>
            <div>
              <select
                className="form-select form-select-solid"
                data-kt-select2="true"
                data-placeholder="Select option"
                data-allow-clear="true"
                value={job}
                onChange={handleJobChange}
                defaultValue="전체"
              >
                <option>전체</option>
                {getUniqueValues(
                  optionList.filter(
                    (c) =>
                      (project === "전체" ? c.project_projectname : c.project_projectname === project) &&
                      (vendor === "전체" ? c.uveVendorNameTB50 : c.uveVendorNameTB50 === vendor) &&
                      (area1 === "전체" ? c.WBSCodeNMLv2 : c.WBSCodeNMLv2 === area1) &&
                      (area2 === "전체" ? c.WBSCodeNMLv3 : c.WBSCodeNMLv3 === area2) &&
                      (construction1 === "전체" ? c.WBSCodeNMLv4 : c.WBSCodeNMLv4 === construction1) &&
                      (construction2 === "전체" ? c.WBSCodeNMLv5 : c.WBSCodeNMLv5 === construction2) &&
                      (step === "전체" ? c.step : c.step === step)
                    // c.step === step,
                  ),
                  "job",
                ).map((option, idx) => (
                  <option key={idx}>{option}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="separator border-gray-200" />
        </div> : ""}

      <div className="px-7 py-5">
        <div className="d-flex justify-content-end">
          <button
            type="reset"
            className="btn btn-sm btn-secondary btn-active-light-primary me-2"
            data-kt-menu-dismiss="true"
            onClick={handleResetClick}
          >
            Reset
          </button>
          <button
            type="submit"
            className="btn btn-sm btn-primary"
            data-kt-menu-dismiss="true"
            onClick={apply}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
    // </div>

  );
}

const getUniqueValues = (arr, key) => {
  const uniqueValues = [...new Set(arr.map((item) => item[key]))];
  return _.sortBy(uniqueValues);
};